import type {ReactElement} from 'react';
import {useState} from 'react';
import {DropdownGhostSelectBox} from '@Components/dropdown-v2/components/dropdown-ghost-select-box';
import {EventDropdown} from '@Components/event-wizard/event-dropdown';
import {ALIGNMENT_TYPE, DROPDOWN_SIZE} from '@Components/dropdown-v2/dropdown.types';
import type {TimeZone} from 'timezones-list';
import {useEventWizardTimeZone} from '@Components/event-wizard/event-wizard.hooks';
import {TimezoneContent} from '@Components/event-wizard/timezone-content';
import type {TimezoneProps} from '@Components/event-wizard/timezone/timezone.types';
import {getTimezoneDisplayLabel} from '@Components/event-wizard/timezone-content/timezone-content.helper';
import styles from './timezone.module.scss';

export function Timezone({mobileDropdownClick, onSelectTimeZone}: TimezoneProps): ReactElement<any> {
  const selectedTimezone: TimeZone = useEventWizardTimeZone();

  const [isDropdownOpen, setDropdownOpen] = useState<boolean>(false);

  const onTimeZoneSelected = (timeZone: TimeZone, wasSelected: boolean): void => {
    setDropdownOpen(wasSelected);

    if (onSelectTimeZone) {
      onSelectTimeZone(timeZone);
    }
  };

  const getSelector = (): ReactElement<any> => {
    return (
      <DropdownGhostSelectBox
        size={DROPDOWN_SIZE.XSMALL}
        textClassName={`${styles.textWrap} spacing-m-r-2`}
        openedClassName={styles.timezoneDropdownSelectorOpened}
        text={getTimezoneDisplayLabel(selectedTimezone, true)}
      />
    );
  };

  return (
    <EventDropdown
      text={window.i18next.t('pmwjs_time_zone')}
      selector={getSelector()}
      popup={<TimezoneContent onSelectTimezone={onTimeZoneSelected} />}
      popupClass={`${styles.popup} _overflow-hidden`}
      popupSpacingClass="spacing-p-t-0 spacing-p-l-3 spacing-p-r-3"
      alignment={ALIGNMENT_TYPE.RIGHT_START}
      open={isDropdownOpen}
      onOpen={() => {
        if (mobileDropdownClick) {
          mobileDropdownClick();
        } else {
          setDropdownOpen(true);
        }
      }}
      onClose={() => {
        setDropdownOpen(false);
      }}
    />
  );
}
